<div class="dialog-container selection">
  <div cdkDrag cdkDragHandle cdkDragRootElement=".cdk-overlay-pane" class="dialog-header">
    <h4>{{ "responsible.selectResponsible" | translate }}</h4>
    <button (click)="dialogRef.close()">
      <fa-icon icon="times"></fa-icon>
    </button>
  </div>
  <div class="container container--search">
    <div class="search-bar">
      <div class="first-row">
        <div class="input-container flex-2">
          <input (keyup)="applyFilter()" [(ngModel)]="inputText" class="primary-input flex-1" matInput placeholder="Search..." type="text" />
        </div>
        <div class="flex-1 filter-container">
          <app-search-bar-filter [filters]="filters" (changeFilter)="loadAll()"></app-search-bar-filter>
        </div>
        <div class="button-container">
          <button class="primary" type="button" (click)="applyFilter()">Search</button>
          <button class="cancel" type="button" (click)="inputText = null; applyFilter()">Clear</button>
        </div>
      </div>
    </div>
  </div>
  <div class="container container--table">
    <div class="section-container table-section">
      <div class="table-container">
        <mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="selected">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>
            <mat-cell *matCellDef="let element">
              <mat-checkbox (change)="changeSelected(element, $event)" [(ngModel)]="element.selected"></mat-checkbox>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="title">
            <mat-header-cell *matHeaderCellDef><span>Title</span></mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span>{{ element.title }}</span>
              @if (element.assignedCountries) {
                <span>{{ element.assignedCountries.join(", ") }}</span>
              }
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="code">
            <mat-header-cell *matHeaderCellDef><span>Code</span></mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span>{{ element.code }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="responsible">
            <mat-header-cell *matHeaderCellDef>
              <span>Responsible</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span>{{ getUser(element, "responsible") }}</span>
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="specialists">
            <mat-header-cell *matHeaderCellDef>
              <span>Specialists</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
              <span>{{ getUser(element, "specialists") }}</span>
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
        </mat-table>
      </div>
      <mat-paginator [pageSize]="10"></mat-paginator>
    </div>
  </div>
  <div class="container container--sticky-bottom">
    <div class="section-container button-container">
      <button (click)="dialogRef.close()" class="cancel" type="button">{{ "default.buttons.cancel" | translate }}</button>
      <button (click)="closeDialog()" class="primary" type="button" [disabled]="!value">{{ "default.buttons.confirm" | translate }}</button>
    </div>
  </div>
</div>
